<template>
	<ui-modal @toggle="emit('toggle')">
		<Head title="Fusion de structures" />
		<form method="post" @submit.prevent="handleSubmit" class="flex flex-col gap-2">
			<ui-title textSize="big" textPosition="left" class="lg:col-span-2 text-slate-700">
				<template v-slot:text>
					<p>Fusionner deux structures</p>
				</template>
			</ui-title>

			<div class="flex flex-col gap-2">
				<div class="grid grid-cols-[1fr_40px_1fr] gap-2 border-b-2 pb-4 items-center">
					<h3 class="text-xl font-bold">Structure actuelle</h3>
					<div></div>
					<form-search type="structure" @select="fusedStructure = $event" :history="true" :excludedIds="[structure.id]"></form-search>
				</div>

				<div class="grid grid-cols-[1fr_40px_1fr] gap-2 items-center" v-if="fusedStructure">
					<p>La structure de cette colonne sera conservée.</p>
					<div></div>
					<p><i class="fas fa-warning text-red-700"></i> La structure de cette colonne sera supprimée !</p>
				</div>

				<div class="flex flex-col gap-2" v-if="fusedContact">
					<!-- NOM -->
					<ui-fuse-field :left="structure.name" :right="fusedStructure?.name" placeholder="Nom" @toggle="fuseSwap.name = $event">
					</ui-fuse-field>

					<!-- Type-->
					<ui-fuse-field
						:left="structure?.type?.name"
						:right="fusedStructure?.type?.name"
						placeholder="Type"
						@toggle="fuseSwap.type = $event" />
					<!-- STATUS-->
					<ui-fuse-field
						:left="structure?.status?.name"
						:right="fusedStructure?.status?.name"
						placeholder="Status"
						@toggle="fuseSwap.status = $event" />

					<!-- ADDRESSE -->
					<ui-fuse-field
						:left="structure.address"
						:right="fusedStructure?.address"
						placeholder="Adresse"
						@toggle="fuseSwap.address = $event" />

					<!-- VILLE -->
					<ui-fuse-field :left="structure.city" :right="fusedStructure?.city" placeholder="Ville" @toggle="fuseSwap.city = $event" />

					<!-- CODE POSTAL -->
					<ui-fuse-field
						:left="structure.postal_code"
						:right="fusedStructure?.postal_code"
						placeholder="Code postal"
						@toggle="fuseSwap.postal_code = $event" />

					<!-- TELEPHONE -->
					<ui-fuse-field :left="structure.phone" :right="fusedStructure?.phone" placeholder="Téléphone" @toggle="fuseSwap.phone = $event" />

					<!-- ADRESSE MAIL -->
					<ui-fuse-field :left="structure.email" :right="fusedStructure?.email" placeholder="E-mail" @toggle="fuseSwap.email = $event" />

					<!-- FINESSE -->
					<ui-fuse-field
						:left="structure.pro_id"
						:right="fusedStructure?.pro_id"
						placeholder="FINESSE"
						@toggle="fuseSwap.pro_id = $event" />

					<!-- Commentaire -->
					<ui-fuse-field
						:left="structure.comment"
						:right="fusedStructure?.comment"
						placeholder="Commentaire"
						@toggle="fuseSwap.comment = $event" />

					<!-- CONTACT -->
					<ui-fuse-field
						:left="structure.contacts?.map((contact) => contact.first_name + ' ' + contact.last_name).join(', ')"
						:right="fusedStructure?.contacts?.map((contact) => contact.first_name + ' ' + contact.last_name).join(', ')"
						placeholder="Contacts"
						@toggle="fuseSwap.contacts = $event" />

					<!-- Historique -->
					<ui-fuse-field
						:left="structure?.logs?.length > 0 ? structure?.logs?.length + ' entrée(s)' : null"
						:right="fusedStructure?.logs?.length > 0 ? fusedStructure?.logs?.length + ' entrée(s)' : null"
						placeholder="Historique"
						@toggle="fuseSwap.history = $event" />
				</div>

				<form-validation-errors class="lg:col-span-2"></form-validation-errors>

				<ui-button
					class="col-span-2 mt-3 font-bold border-2"
					position="center"
					@click.prevent="handleSubmit"
					:loading="loading"
					v-if="fusedStructure">
					<template v-slot:text>Valider</template>
				</ui-button>
			</div>
		</form>
	</ui-modal>
</template>

<script setup>
	import { ref, reactive, onMounted } from 'vue';
	import { router, useForm, usePage } from '@inertiajs/vue3';

	// Define props
	const props = defineProps({
		statuses: {
			type: Object,
			default: null,
		},
		structure: {
			type: Object,
			default: null,
		},
	});

	// Define emits
	const emit = defineEmits(['toggle']);

	// Reactive state
	const loading = ref(false);
	const formLoading = ref(false);
	const errors = ref(null);
	const fusedStructure = ref(null);

	// Keep track of which fields to keep (false = left/current, true = right/searched)
	const fuseSwap = useForm({
		target: false,
		status: false,
		type: false,
		name: false,
		email: false,
		phone: false,
		address: false,
		postal_code: false,
		city: false,
		pro_id: false,
		comment: false,
		dr_id: false,
		contacts: false,
		history: false,
	});

	function handleSubmit() {
		formLoading.value = true;
		fuseSwap.post(route('structures.fusion', { structure: props.structure.id, fusion: fusedStructure.value.id }), {
			onSuccess: () => {
				emit('toggle');
				router.reload({ only: ['structure'] });
				formLoading.value = false;
			},
			onError: () => {
				formLoading.value = false;
			},
			onFinish: () => {
				formLoading.value = false;
			},
		});
	}

	// Lifecycle hooks
	onMounted(() => {
		// Any initialization code if needed
	});
</script>
